import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, take } from 'rxjs/operators';
import { check24DeploymentFromHostname } from '../../config/check24-environment';
import { getAuthCallbackUrl } from '../../utils/auth-callback-url';
import { ResultpageService } from './resultpage.service';

type AuthEnv = 'prod' | 'test';

const ACCOUNTS_BASE: Record<AuthEnv, string> = {
  prod: 'https://accounts.check24.at',
  test: 'https://accounts.check24-test.at',
};

const SMILY_BASE: Record<AuthEnv, string> = {
  prod: 'https://smily.check24.at',
  test: 'https://smily.check24-test.at',
};

declare const window: Window & { location: Location };

@Injectable({
  providedIn: 'root',
})
export class LoginService {
  public loginPopup = false;
  public basePath!: string;

  private readonly apiProduct = 'atfinkre';
  private readonly env: AuthEnv;

  constructor(private resultpageService: ResultpageService) {
    this.env = this.resolveAuthEnv();
  }

  get smilyOnboardingUrl(): string {
    const callback = encodeURIComponent(getAuthCallbackUrl());
    return `${SMILY_BASE[this.env]}/onboarding?callback=${callback}`;
  }

  get loginWithSmilyUrl(): string {
    return this.buildAccountsAuthUrl(
      'prepare',
      encodeURIComponent(this.smilyOnboardingUrl),
    );
  }

  checkLogin(): Observable<unknown> {
    return this.resultpageService.checkLogin().pipe(
      take(1),
      catchError((error) => {
        if (error?.status === 403) {
          window.location.href = this.buildAccountsAuthUrl(
            'prepare',
            encodeURIComponent(getAuthCallbackUrl()),
          );
        }
        return throwError(() => error);
      }),
    );
  }

  private resolveAuthEnv(): AuthEnv {
    return check24DeploymentFromHostname(window.location.hostname) === 'prod'
      ? 'prod'
      : 'test';
  }

  private buildAccountsAuthUrl(
    path: 'prepare' | 'logout',
    callback: string,
  ): string {
    const base = ACCOUNTS_BASE[this.env];
    return `${base}/auth/${path}?callback=${callback}&api_product=${this.apiProduct}&sso_env=${this.env}&loc=de_at`;
  }
}
